// VFX: Cinematic Title Sequence
// Category: intros-outros · Tags: intro, cinematic, letterbox, title, film
// Barras pretas de letterbox comprimem de cima e baixo, titulo fade in.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

const TITLE = "THE STORY";
const TAGLINE = "begins here";

export default function CtaCinematicTitleLetterbox1200Ms() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const barSp = spring({ frame, fps, config: { stiffness: 80, damping: 18 } });
  const titleSp = spring({ frame: frame - 20, fps, config: { stiffness: 60, damping: 16 } });
  const barH = interpolate(barSp, [0, 1], [220, 90]);

  return (
    <AbsoluteFill style={{ background: "#0a0e1a" }}>
      <AbsoluteFill style={{
        background: "radial-gradient(ellipse at center, #1e293b 0%, #0a0e1a 100%)",
      }} />
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: barH, background: "#000" }} />
      <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: barH, background: "#000" }} />
      <AbsoluteFill style={{ alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 12 }}>
        <p style={{
          margin: 0, fontSize: 84, fontWeight: 200, color: "#f8fafc", letterSpacing: "0.4em",
          textTransform: "uppercase", opacity: titleSp,
          transform: `scale(${interpolate(titleSp, [0, 1], [0.92, 1])})`,
          fontFamily: "serif",
        }}>{TITLE}</p>
        <p style={{
          margin: 0, fontSize: 20, color: "rgba(248,250,252,0.4)", letterSpacing: "0.3em",
          opacity: titleSp * 0.8, textTransform: "lowercase", fontFamily: "serif",
        }}>{TAGLINE}</p>
      </AbsoluteFill>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
